// Shared button styling for the Microsoft/Apple/LinkedIn "continue with"
// buttons in SocialLoginButtons — the three sx blocks were pixel-identical
// (fb#547 item 2). Reads theme.custom.wizard for the shared field radius,
// mirroring the amberCtaSx.js idiom. `isPending` is whether THIS button is
// the one currently loading (drives the "stay active while disabled" look).
import { alpha } from "@mui/material/styles";

// theme.palette isn't guaranteed present (see tests that mock useTheme with
// a bare { custom: {} }) — shared fallback for this and SocialLoginButtons.jsx.
export function getTextPrimary(theme) {
    return theme.palette?.text?.primary ?? "#F4F2EE";
}

export function providerButtonSx(theme, isPending) {
    const w = theme.custom?.wizard ?? {};
    const textPrimary = getTextPrimary(theme);

    return {
        textTransform: "none",
        fontWeight: 500,
        minHeight: 44,
        color: textPrimary,
        bgcolor: "rgba(0,0,0,0.55)",
        border: "1px solid rgba(244,242,238,0.18)",
        borderRadius: w.fieldRadius ? `${w.fieldRadius}px` : "10px",
        boxShadow: "none",
        "&:hover": {
            bgcolor: "rgba(0,0,0,0.65)",
            boxShadow: "none",
            borderColor: "rgba(244,242,238,0.28)",
        },
        // Keep the spinner-pending button visually active (don't dim it like
        // the other disabled buttons) so the user sees which provider is in flight.
        "&.Mui-disabled": isPending ? {
            color: textPrimary,
            bgcolor: "rgba(0,0,0,0.55)",
            borderColor: "rgba(244,242,238,0.18)",
        } : {
            color: alpha(textPrimary, 0.5),
            bgcolor: "rgba(0,0,0,0.35)",
            borderColor: "rgba(244,242,238,0.10)",
        },
    };
}
